import axios, { AxiosInstance } from 'axios';
import { IError } from 'type/db';

import { getCookie } from 'utils/cookies';

export const api = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
});

const apiInterseptors = (axios_instance_arr: AxiosInstance[]) =>
	axios_instance_arr.forEach((item) => {
		item.interceptors.request.use(
			function (config) {
				const token = getCookie('Authorization');
				//url에 login이 없으면 login이면 초기화
				if (token && !config.url?.includes('login')) {
					if (!config.headers) {
						config.headers = {};
					}

					config.headers.Authorization = `Token ${token}`;
				}
				if (config.url?.includes('login')) {
					if (!config.headers) {
						config.headers = {};
					}
					delete config.headers.Authorization;
				}
				return config;
			},
			function (error) {
				return Promise.reject(error);
			},
		);
		// 에러 응답 내에서 데이터만 반환
		item.interceptors.response.use(
			function (response) {
				return response;
			},
			function (error: IError) {
				if (error.response?.status === 401) {
					window.location.replace('/login');
				}
				console.log(error);
				return Promise.reject(error.response.data);
			},
		);
	});

apiInterseptors([api]);
